import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { Checkbox } from "@fronterahealth/frontera-ui-components/ui/checkbox";
import { Field, FieldError, FieldLabel } from "@fronterahealth/frontera-ui-components/ui/field";

import { ReportFieldDisabledValue } from "@components/ReportField/ReportFieldDisabledValue";
import { getCheckedOptions, parseCheckboxContent } from "@components/ReportField/inputs/choiceContent";
import { ReportFieldInputProps } from "@components/ReportField/types";

export const ReportFieldCheckbox: React.FC<ReportFieldInputProps> = ({ id, value, onChange, variant, disabled }) => {
  const result = parseCheckboxContent(value);

  if (!result.success) return <FieldError errors={result.error.issues} />;

  const { options, answer } = result.data;

  const toggle = (option: string, checked: boolean) => {
    const next = checked ? [...answer, option] : answer.filter((selected) => selected !== option);
    onChange(JSON.stringify({ options, answer: next }));
  };

  if (disabled) {
    return <ReportFieldDisabledValue value={getCheckedOptions(result.data).join(", ")} />;
  }

  return (
    <div
      className={cn(
        "flex flex-col gap-4 rounded-lg border border-input px-4 py-2",
        variant === "ghost" &&
          "-my-2 transition-[color,box-shadow,padding,border-color] [&:not(:hover):not(:focus-visible)]:border-transparent [&:not(:hover):not(:focus-visible)]:px-0",
      )}
    >
      {options.map((option) => (
        <Field key={option} orientation="horizontal">
          <Checkbox
            id={`${id}-${option}`}
            checked={answer.includes(option)}
            onCheckedChange={(checked) => toggle(option, checked)}
          />
          <FieldLabel htmlFor={`${id}-${option}`}>{option}</FieldLabel>
        </Field>
      ))}
    </div>
  );
};
